import { BooleanFilter } from "./boolean-filter";
import { DateFilter } from "./date-filter";
import { IntegerFilter } from "./integer-filter";
import { ItemFilter } from "./item-filter";
import { StringFilter } from "./string-filter";

export class OrdInspectionRequestDispatchFilter {
    public id?: IntegerFilter;
    public assetNumber?: StringFilter;
    public assetDescription?: StringFilter;
    public form?: ItemFilter;
    public status?: ItemFilter;
    public route?: ItemFilter;
    public task?: ItemFilter;
    public startDate?: DateFilter;
    public dueDate?: DateFilter;
    public dispatchDate?: DateFilter;
    public dispatchNumber?: StringFilter;
    public personnel?: ItemFilter;
}
